import React from "react";
import { Props } from "./types";
import { useTranslation } from "react-i18next";
import { FolderIcon } from "../folderIcon";
import { useSelectDocumentsContext } from "../../context";
import styles from "./styles.scss";

function FolderCard({ folder }: Props) {
  const { t } = useTranslation();
  const { setCurrentFolder } = useSelectDocumentsContext();

  return (
    <div
      className={styles.folderCard}
      onClick={() => setCurrentFolder(folder.uuid)}
    >
      <FolderIcon className={styles.folderIcon} />
      <div className={styles.folderInfo}>
        <p>{folder.name}</p>
        <span className={styles.numberOfChildren}>
          {folder.children.length}{" "}
          {t(
            `selectDocuments.folderCard.element${
              folder.children.length > 1 ? "s" : ""
            }`,
          )}
        </span>
      </div>
    </div>
  );
}

export { FolderCard };
